import { defineChain } from 'viem'

export const Test_Bnb = defineChain({
  id: 56,
  name: 'Bnb',
  nativeCurrency: {
    decimals: 18,
    name: 'BNB',
    symbol: 'BNB',
  },
  rpcUrls: {
    default: {
      http: ['https://bsc-dataseed.binance.org/']
    },
  },
  blockExplorers: {
    default: { name: 'Explorer', url: 'https://bscscan.com'  },
  } 
})

// export const Test_Bnb = defineChain({
//   id: 97,
//   name: 'Bnb Testnet',
//   nativeCurrency: {
//     decimals: 18,
//     name: 'tBNB',
//     symbol: 'tBNB',
//   },
//   rpcUrls: {
//     default: {
//       http: ['https://bsc-testnet.bnbchain.org']//'https://rpc.sentio.xyz/bsc-testnet'],
//       //webSocket: ['wss://rpc.zora.energy'],
//     },
//   },
//   blockExplorers: {
//     default: { name: 'Explorer', url: 'https://bsc-testnet.bnbchain.org' }//'https://testnet.bscscan.com/' },
//   },
//   /*contracts: {
//     multicall3: {
//       address: '0xcA11bde05977b3631167028862bE2a173976CA11',
//       blockCreated: 5882,
//     },
//   },*/
// })

